import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { registerUser } from "../modules/actions";
import { getInsurances } from "../../Insurance/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    insurances: state.insuranceReducer.insurances,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      registerUser,
      getInsurances,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
